import { Endpoint } from '../endpoint';

export const ReferenceValueView = new Endpoint('reference_value_view');
